import { render } from "./InterviewFailAction.vue?vue&type=template&id=5534cb09"
import script from "./InterviewFailAction.vue?vue&type=script&lang=js"
export * from "./InterviewFailAction.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__